import type { Token } from '@/types/token'

export const DEFAULT_TOKENS: Token[] = [
  {
    "address": "S",
    "symbol": "S",
    "name": "Sonic",
    "decimals": 18
  },
  {
    "address": "0x039e2fB66102314Ce7b64Ce5Ce3E5183bc94aD38",
    "symbol": "wS",
    "name": "Wrapped Sonic",
    "decimals": 18
  },
  {
    "address": "0x29219dd400f2Bf60E5a23d13Be72B486D4038894",
    "symbol": "USDC",
    "name": "USD Coin",
    "decimals": 6
  },
  {
    "address": "0x50c42dEAcD8Fc9773493ED674b675bE577f2634b",
    "symbol": "WETH",
    "name": "Wrapped Ether",
    "decimals": 18
  },
  {
    "address": "0x56e344be9a7a7a1d27c854628483efd67c11214f",
    "symbol": "stS",
    "name": "Beets Staked Sonic",
    "decimals": 18
  }
]
